import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { VideoAutoplay } from '../video-autoplay/video-autoplay';

@Component({
  selector: 'fr8bot-web-entity-home-section',
  templateUrl: './web-entity-home-section.html',
  styleUrl: './web-entity-home-section.scss',
  imports: [VideoAutoplay],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebEntityHomeSection {
  videoSrc = input('');
  posterSrc = input('');
}
